import { Link, TableBody, TableCell, TableRow } from '@material-ui/core'

import React, { FC } from 'react'

import { COMPANY_STATUS } from '../constants/enums/company.enum.constant'
import { CompanyListInterface } from '../interfaces/company'
import { convertDateTimeToString } from '../utils/common'

type Props = {
  companies: CompanyListInterface[]
}

const CompanyTableBody: FC<Record<string, unknown> & Props> = ({
  companies
}) => (
  <TableBody>
    {companies.map((company: CompanyListInterface) => (
      <TableRow key={company.companyId} hover={true}>
        <TableCell align="center">
          <Link
            href={
              company.status === COMPANY_STATUS.archived
                ? `/company/${company.companyId}/view`
                : `/company/${company.companyId}/edit`
            }
          >
            {company.companyId}
          </Link>
        </TableCell>
        <TableCell align="center">{company.companyNo}</TableCell>
        <TableCell align="center">{company.country}</TableCell>
        <TableCell align="center">{company.profileCategory}</TableCell>
        <TableCell align="center">{COMPANY_STATUS[company.status]}</TableCell>
        <TableCell align="center">{company.verified.toString()}</TableCell>
        <TableCell align="center">
          {convertDateTimeToString(company.createdTime)}
        </TableCell>
        <TableCell align="center">
          {convertDateTimeToString(company.updatedTime)}
        </TableCell>
        <TableCell align="center">{company.updatedByEmail}</TableCell>
      </TableRow>
    ))}
  </TableBody>
)

export default CompanyTableBody
